var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.224,
    height: 30.6,
    viewBox: "0 0 52.224 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount",
    transform: "translate(0 -106)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.492,
    cy: 1.492,
    r: 1.492,
    transform: "translate(18.651 115.332)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.492,
    cy: 1.492,
    r: 1.492,
    transform: "translate(30.588 124.284)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M47.634,106H4.59A4.6,4.6,0,0,0,0,110.59v6.12a1.529,1.529,0,0,0,1.53,1.53H3.06a3.06,3.06,0,1,1,0,6.12H1.53A1.529,1.529,0,0,0,0,125.89v6.12a4.6,4.6,0,0,0,4.59,4.59H47.634a4.6,4.6,0,0,0,4.59-4.59v-6.12a1.529,1.529,0,0,0-1.53-1.53h-1.53a3.06,3.06,0,1,1,0-6.12h1.53a1.529,1.529,0,0,0,1.53-1.53v-6.12A4.6,4.6,0,0,0,47.634,106ZM15.4,116.71a4.59,4.59,0,1,1,4.59,4.59A4.6,4.6,0,0,1,15.4,116.71Zm3.634,13.435a1.533,1.533,0,0,1-.239-2.152l12.24-15.3a1.531,1.531,0,0,1,2.391,1.913l-12.24,15.3A1.533,1.533,0,0,1,19.036,130.145Zm13.2.335a4.59,4.59,0,1,1,4.59-4.59A4.6,4.6,0,0,1,32.232,130.48Z",
    transform: "translate(0 0)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.cacfdbe3e1f1e174ac865f507b24df6e.svg";
export { ForwardRef as ReactComponent };